import styled from 'styled-components';
import { Typ20, Typ42 } from 'dc/Typ';
import APH120 from 'dc/APH120';
import { ShortWrapper } from '../../elements';

export const Wrapper = styled(ShortWrapper)`
  background: #ffffff;
`;

export const ProfileWrapper = styled.div`
  width: 100%;
  padding: 16px;
`;

export const Header = styled(APH120)`
  > div > i {
    color: #607d8b;
  }
`;

export const InnerWrapper = styled.div`
  background: #007299;
  padding: 18px 16px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SmallText = styled(Typ20)`
  text-align: center;
  color: #fff;
`;

export const MainText = styled(Typ42)`
  margin-bottom: 9px;
  text-align: center;
  color: #fff;
`;
